module.exports = __webpack_public_path__ + "img/logo.2cfa9572.png";